import styled from '@emotion/styled';
import FileChip from '../FileChip';

const ExternalFileChip = styled(FileChip)({
  paddingLeft: 6,
});

export default ExternalFileChip;
